import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const AIservice = () => {
  return (
    <div className="sf-services">
      <h3>AI Automation Services</h3>
      <p className="sf-description">
        Get advanced ai automation services to streamline workflows, boost
        productivity, and reduce costs. Leverage ai powered automation,
        chatbots, and machine learning to scale your business faster and
        smarter.
      </p>
      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>AI-Powered Analytics & Insights</h3>
          <p>
            {" "}
            Our AI analytics platform processes massive amounts of data to
            uncover actionable insights about your customers. We identify
            patterns, predict behavior, and provide recommendations to optimize
            your marketing campaigns.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Marketing Automation</h3>
          <p>
            Automate repetitive tasks and nurture leads at scale. Our AI-driven
            automation platform manages email campaigns, social media posting,
            lead scoring, and customer segmentation with minimal manual
            intervention.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Predictive Analytics & Forecasting</h3>
          <p>
            Predict customer behavior, market trends, and sales outcomes with
            AI-powered forecasting. Our models help you make data-driven
            decisions and stay ahead of market changes.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>AI-Powered Personalization</h3>
          <p>
            Deliver personalized experiences to every customer at scale. Our AI
            engines analyze user behavior and preferences to customize content,
            product recommendations, and marketing messages.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>AI Chatbots & Customer Support</h3>
          <p>
            Deploy intelligent chatbots powered by natural language processing
            to handle customer inquiries 24/7. Our AI assistants improve
            customer satisfaction while reducing support costs.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>AI Content Generation & Optimization</h3>
          <p>
            {" "}
            Generate compelling marketing copy, headlines, and content
            recommendations using AI. Our AI optimizes content for engagement,
            SEO, and conversion rates.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Campaign Optimization & A/B Testing</h3>
          <p>
            Our AI algorithms continuously optimize your campaigns,
            automatically testing variations and allocating budget to
            top-performing strategies for maximum ROI.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIservice;
